"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Render components conditionally, is shortand from: "conditional render"
 * @param {Array} conditions - an array of pairs with condition and value
 * [{cond: boolean, val: any|() => any}]
 * @param {boolean} [multiple=false] - render all matched or only first (pass as last argument)
 * @returns {any|any[]|null} - rendered component or array of rendered
 * components or null
 *
 * @example cr([condition1, <AnyComponent />], [condition2, <AnotherComponent />], multiplyFlag)
 */
const cr = (...conditions) => {
  let multiple = false;
  /* pop last argument if it is a boolean */

  if (typeof conditions[conditions.length - 1] === 'boolean') {
    multiple = conditions.pop();
  }
  /* filter and map matched */


  const matchedItems = conditions.filter(([cond, val]) => cond && val).map(([, val]) => typeof val === 'function' ? val() : val);
  /* return array of rendered components or first rendered or null */

  return multiple ? matchedItems : matchedItems[0] || null;
};

var _default = cr;
exports.default = _default;